import type { UTag } from '../typings'

// eslint-disable-next-line @typescript-eslint/no-namespace
declare namespace window {
  const utag: UTag
}

/**
 * Single page application helper
 * https://docs.tealium.com/platforms/javascript/single-page-applications
 */
export default {
  /**
   * Track view
   * https://docs.tealium.com/platforms/javascript/single-page-applications/#track-views
   */
  view(): void {
    if (window.utag) {
      window.utag.view()
    }
  }
}
